import {Component} from '@angular/core';
import {BaseSubcomp} from '../../../base-subcomp';

@Component({
    selector: 'app-lsc-subcomp-parent',
    templateUrl: './lsc-subcomp-parent.component.html',
    styleUrls: ['./lsc-subcomp-parent.component.scss'],
    standalone: false
})
export class LscSubcompParentComponent extends BaseSubcomp
{

}
